import { router } from '@inertiajs/vue3'
import { usePage } from '@inertiajs/vue3';

async function toggleFavorite(type, identifier) {
    await axios.post(`/toggle-favorite`, {
        type: type,
        identifier: identifier,
    }).then(response => {
        router.reload({ only: ['favorites'] });
    });
}

export function hasFavoritedCampaign(campaignSlug) {
    return usePage().props.favorites.campaigns.includes(campaignSlug);
}

export function toggleCampaignAsFavorite(campaignSlug) {
    toggleFavorite('campaign', campaignSlug);
}
